// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"7e0d9923","534":"ee9ac8ea"}[chunkId] + ".chunk.js";
};